/** See `src/i18n/locales/en/companies.ts`. */
export const companies = {
  list: {
    title: 'Bedrijven',
    newCompany: 'Nieuw bedrijf',
    empty: 'Er zijn geen bedrijven voor je zichtbaar.',
    name: 'Naam',
    created: 'Aangemaakt',
    rowsLabel: 'de bedrijven',
    healthTitle: 'Organisatiegezondheid',
    healthCompanies: 'Bedrijven',
    healthEditions: 'Edities',
    healthPilots: 'Pilots',
    healthPilotsLabel: 'de pilotsamenvatting',
    healthActivePilotCount: '{{count}} bedrijven met een actieve pilot',
  },
  detail: {
    thisCompany: 'bedrijf',
    rename: 'Naam wijzigen',
    companyAdmins: 'Bedrijfsbeheerders',
    delete: 'Verwijderen',
    departmentsTitle: 'Afdelingen',
    newDepartment: 'Nieuwe afdeling',
    departmentsEmpty: 'Nog geen afdelingen.',
    departmentsLabel: 'de afdelingen',
    name: 'Naam',
    statistics: 'Statistieken',
    collectiveConsent: 'Collectieve toestemming',
    inForce: 'van kracht',
    settingsTitle: 'Instellingen',
    settingsLabel: 'de instellingen',
    change: 'Wijzigen',
    minGroupSizeLabel: 'Minimale groepsgrootte voor aggregaten:',
    systemDefault: 'systeemstandaard',
    companyOverride: 'bedrijfsoverschrijving',
    domainsTitle: 'E-maildomeinen',
    domainsLabel: 'de domeinen',
    manage: 'Beheren',
    domainsEmpty: 'Geen domeinen geregistreerd.',
    membersTitle: 'Leden',
    membersLabel: 'de leden',
    addPerson: 'Persoon toevoegen',
    membersEmpty: 'Geen leden.',
    email: 'E-mail',
    login: 'Inloggen',
    source: 'Bron',
    actions: 'Acties',
    yes: 'ja',
    no: 'nee',
  },
  form: {
    newTitle: 'Nieuw bedrijf',
    name: 'Naam',
    cancel: 'Annuleren',
    create: 'Bedrijf aanmaken',
    editTitle: 'Bedrijfsnaam wijzigen',
    save: 'Opslaan',
    deleteTitle: 'Bedrijf verwijderen',
    deleteLead:
      '{{name}} verwijderen beëindigt ook de domeinen en lidmaatschappen. Dit kan niet ongedaan worden gemaakt. Typ de bedrijfsnaam ter bevestiging.',
    companyNameLabel: 'Bedrijfsnaam',
    deletePermanently: 'Definitief verwijderen',
    settingsTitle: 'Aggregatiedrempel',
    settingsLead:
      'De minimale groepsgrootte waaronder aggregaten niet worden getoond. Laat leeg om terug te vallen op de systeemstandaard. De API dwingt een harde ondergrens af.',
    minGroupSize: 'Minimale groepsgrootte',
    domainsTitle: 'E-maildomeinen',
    domainsLead:
      'Een geverifieerd adres op een van deze domeinen sluit de houder ervan bij aanmelding aan bij dit bedrijf. Bestaande lidmaatschappen blijven bestaan als een domein wordt verwijderd.',
    remove: 'Verwijderen',
    addDomain: 'Domein toevoegen',
    add: 'Toevoegen',
    backToCompany: 'Terug naar het bedrijf',
  },
  health: {
    title: 'Organisatiegezondheid',
    edition: 'Editie',
    editionFit: 'Fit',
    editionSoccer: 'Soccer',
    members: 'Leden',
    pilotsTitle: 'Pilots',
    pilotsLabel: 'de pilotstatus',
    noPilots: 'Nog geen pilots.',
    activeCount: '{{count}} actief',
    scaledCount: '{{count}} opgeschaald',
    totalCount: '{{count}} totaal',
    viewAllPilots: 'Alle pilots bekijken',
  },
} as const;
